var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Modal",
    {
      attrs: { width: 1200, "footer-hide": true, title: "现售报损" },
      on: { "on-visible-change": _vm.onShowChange },
      model: {
        value: _vm.show,
        callback: function ($$v) {
          _vm.show = $$v
        },
        expression: "show",
      },
    },
    [
      _c(
        "Card",
        { attrs: { padding: 0, bordered: false, "dis-hover": true } },
        [
          _c(
            "Row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "Col",
                { attrs: { span: "18" } },
                [
                  _c(
                    "Row",
                    { attrs: { gutter: 16 } },
                    [
                      _c(
                        "Col",
                        { attrs: { span: "24" } },
                        [
                          _c("search-card", {
                            attrs: {
                              form: _vm.mainTable.searchForm,
                              "table-load-event": _vm.getDiscardTableRecord,
                              "table-search": _vm.mainTable.tableSearch,
                              colSpan: 6,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Row",
                    { attrs: { gutter: 16 } },
                    [
                      _c(
                        "Col",
                        { attrs: { span: "24" } },
                        [
                          _c("stand-pagination-table", {
                            attrs: {
                              columns: _vm.mainTable.columns,
                              data: _vm.storeList,
                              autoHeight: true,
                              loading: _vm.mainTable.loading,
                              "table-search": _vm.mainTable.tableSearch,
                              "table-load-event": _vm.getDiscardTableRecord,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Col",
                { attrs: { span: "6" } },
                [
                  _c(
                    "Row",
                    { staticClass: "row-margin-top-15", attrs: { gutter: 16 } },
                    [
                      _c(
                        "Col",
                        { attrs: { span: "24" } },
                        [
                          _c(
                            "Form",
                            {
                              staticClass: "small-form",
                              attrs: { "label-position": "top" },
                            },
                            [
                              _c(
                                "Row",
                                { attrs: { gutter: 16 } },
                                [
                                  _c(
                                    "Col",
                                    { attrs: { span: "24" } },
                                    [
                                      _c(
                                        "FormItem",
                                        { attrs: { label: "视频" } },
                                        [
                                          _c("single-file-upload-with-name", {
                                            attrs: { format: ["mp4", "jpg"] },
                                            model: {
                                              value: _vm.discard.form.video,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.discard.form,
                                                  "video",
                                                  $$v
                                                )
                                              },
                                              expression: "discard.form.video",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "Row",
                                { attrs: { gutter: 16 } },
                                [
                                  _c(
                                    "Col",
                                    { attrs: { span: "24" } },
                                    [
                                      _c(
                                        "FormItem",
                                        { attrs: { label: "备注" } },
                                        [
                                          _c("Input", {
                                            attrs: {
                                              type: "textarea",
                                              rows: 4,
                                            },
                                            model: {
                                              value: _vm.discard.form.remark,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.discard.form,
                                                  "remark",
                                                  $$v
                                                )
                                              },
                                              expression: "discard.form.remark",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "Row",
                                { attrs: { gutter: 16 } },
                                [
                                  _c(
                                    "Col",
                                    {
                                      staticStyle: { "text-align": "right" },
                                      attrs: { span: "24" },
                                    },
                                    [
                                      _c(
                                        "Button",
                                        {
                                          attrs: {
                                            type: "primary",
                                            loading: _vm.btnLoading,
                                          },
                                          on: { click: _vm.submitDiscard },
                                        },
                                        [_vm._v("提交报损")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }